import {
  AmazonOrderDetailsContract,
  IAmazonPayService,
} from '../../types/AmazonPay';
import { ConfigEnabledPaymentMethodContract } from '../../types/Configuration';
import { AmazonPayServiceConfig } from '../../types/ServiceConfigurations';

type AmazonBuyerContract = {
  Email: string;
};

type AmazonDestinationContract = {
  Name: string | null;
  AddressLine1: string | null;
  AddressLine2: string | null;
  City: string | null;
  CountryName: string | null;
  PostalCode: string | null;
  StateOrRegion: string | null;
  Phone: string | null;
};

type AmazonOrderReferenceDetails = {
  Buyer: AmazonBuyerContract;
  Destination: { PhysicalDestination: AmazonDestinationContract };
};

type AmazonGetOrderReferenceDetailsResponse = {
  GetOrderReferenceDetailsResponse: {
    GetOrderReferenceDetailsResult: {
      OrderReferenceDetails: AmazonOrderReferenceDetails;
    };
  };
};

type AmazonPaymentEndpointResponse = {
  Result: string;
};

class AmazonPayService implements IAmazonPayService {
  private storeUrl: string;

  constructor(config: AmazonPayServiceConfig) {
    this.storeUrl = config.apiUrl;
  }

  public getOrderDetails = async (
    orderReferenceId: string,
    accessToken: string
  ): Promise<AmazonOrderDetailsContract> => {
    const response = await window.fetch(
      `${this.storeUrl}/net/AmazonPaymentEndpoint.ashx?Method=GetOrderReferenceDetails&AmazonOrderReferenceId=${orderReferenceId}&AddressConsentToken=${accessToken}`
    );
    const endpointResponse =
      (await response.json()) as AmazonPaymentEndpointResponse;
    const getOrderDetailsResponse = (
      JSON.parse(
        endpointResponse.Result
      ) as AmazonGetOrderReferenceDetailsResponse
    ).GetOrderReferenceDetailsResponse;
    const {
      Buyer,
      Destination: { PhysicalDestination },
    } =
      getOrderDetailsResponse.GetOrderReferenceDetailsResult
        .OrderReferenceDetails;
    const names = PhysicalDestination.Name?.split(' ');

    return {
      emailAddress: Buyer.Email,
      firstName: names?.[0] ?? null,
      lastName: names?.[names.length - 1] ?? null,
      address1: PhysicalDestination.AddressLine1,
      address2: PhysicalDestination.AddressLine2,
      city: PhysicalDestination.City,
      state: PhysicalDestination.StateOrRegion,
      country: PhysicalDestination.CountryName,
      postalCode: PhysicalDestination.PostalCode,
      phoneNumber: PhysicalDestination.Phone,
    };
  };

  public static findAmazonPayPaymentMethod = (
    enabledPaymentMethods: ConfigEnabledPaymentMethodContract[]
  ): ConfigEnabledPaymentMethodContract | undefined => {
    return enabledPaymentMethods.find(
      (method: ConfigEnabledPaymentMethodContract) => {
        return (
          method.methodType &&
          method.methodType.toLowerCase().includes('amazon')
        );
      }
    );
  };
}

export default AmazonPayService;
